import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WMAIApiService, AppInformationService } from '../../core/services/';
import { Tappa, Ost, SchedaIntense, Word, Immagine, Allegati, Experience } from '../../core/models';
import { AuthService } from '../../core/services/auth.service';
import { WgisService } from '../../wgis/wgis.service';
import { WGisDisplayMode } from '../../wgis/wgis.utils';
import { Angulartics2 } from 'angulartics2';
import { BreakpointObserver } from '@angular/cdk/layout';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ConfirmModal, SimpleModal } from '../../core/templates';
import { SuiModalService, ModalSize } from 'ng2-semantic-ui';

declare var $: any;

@Component({
  selector: 'app-schedaintense-main',
  templateUrl: './schedaintense-main.component.html'
})

export class SchedaintenseMainComponent implements OnInit {
  schedaintense: SchedaIntense;
  idscheda: number;
  isMapVisible: boolean = false;
  tappe: Tappa[] = [];
  selectedTappa: Tappa;

  osts: Ost[] = [];
  selectedOst: Ost;
  ostAllegati: Allegati[] = [];
  ostImmagini: Immagine[] = [];
  ostImmagine: Immagine;
  currentOstIndex: number = 0;
  maxOstIndex: number = 0;
  isUserLoggedIn: boolean = false;
  userid: string;
  loading: boolean = true;
  isSmallScreen: boolean = false;
  isMobile: boolean = false;
  //immagini: string[] = [];
  immagine: Immagine;
  currentIndex: number = 0;
  maxIndex: number = 0;

  firstStep: boolean = false;
  secondStep: boolean = false;
  thirdStep: boolean = false;

  esperienze: Experience[] = [];

  segnalazioneForm: FormGroup;
  segnalazioneValue: string;
  segnalazioneText: string;
  showSegnalazione = true;
  wordsSegnalazione: Word[] = [];
  paramsSubscription: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private wmaiservice: WMAIApiService,
    private auth: AuthService,
    private wgisservice: WgisService,
    private angulartics2: Angulartics2,
    private breakpointObserver: BreakpointObserver,
    private translateService: TranslateService,
    private formBuilder: FormBuilder,
    private modalService: SuiModalService,
    private appService: AppInformationService
  ) {
    this.isUserLoggedIn = this.auth.isUserLoggedIn();
    this.isSmallScreen = this.breakpointObserver.isMatched('(max-width: 768px)');
    this.isMobile = this.appService.iAmMobile();
    this.wgisservice.wgisVisible.subscribe((mode: WGisDisplayMode) => {
      this.isMapVisible = (mode !== WGisDisplayMode.Invisible);
    });

    this.angulartics2.eventTrack.next({
      action: 'creaEsperienza',
      properties: { label: 'SchedaInteseMainCreate' },
    });

    this.angulartics2.eventTrack.next({
      action: 'displaymap',
      properties: { label: 'SchedaInteseMainShowMappa' },
    });

    const segnalazioneValueCtrl = new FormControl(this.segnalazioneValue, [Validators.required]);
    const segnalazioneTextCtrl = new FormControl(this.segnalazioneText, [Validators.required]);

    this.segnalazioneForm = this.formBuilder.group({
      segnalazioneValue: new FormControl(segnalazioneValueCtrl),
      segnalazioneText: new FormControl(segnalazioneTextCtrl)
    });

    this.segnalazioneForm.controls['segnalazioneText'].patchValue('');
  }

  ngOnInit() {
    this.wgisservice.clearSelection();

    this.isMapVisible = this.wgisservice.getMapVisible();
    window.scrollTo(0, 0)

    //this.idscheda = this.activatedRoute.snapshot.params.id;
    this.paramsSubscription = this.activatedRoute.params.subscribe((param: any) => {
      this.resetVariables();
      this.idscheda = param['id'];
      if (this.idscheda != null) {
        this.wmaiservice.querySingleSchedaIntense(this.idscheda, this.translateService.getDefaultLang()).subscribe(data => {
          if (data[0] != null) {
            // console.log(data[0]);
            this.schedaintense = data[0];
            this.wmaiservice.schedaDifficoltaById(this.idscheda, this.translateService.getDefaultLang()).subscribe(difficolta => {
              if (difficolta != null && difficolta.length > 0)
                this.schedaintense.difficolta = difficolta;
            });
            this.wmaiservice.schedaFruizioneById(this.idscheda, this.translateService.getDefaultLang()).subscribe(fruizione => {
              if (fruizione != null && fruizione.length > 0)
                this.schedaintense.fruizione = fruizione;
            });
            this.wmaiservice.schedaReteById(this.idscheda, this.translateService.getDefaultLang()).subscribe(rete => {
              if (rete != null && rete.length > 0)
                this.schedaintense.rete = rete;
            });
            this.wmaiservice.schedaSegnaleticaById(this.idscheda, this.translateService.getDefaultLang()).subscribe(segnaletica => {
              if (segnaletica != null && segnaletica.length > 0)
                this.schedaintense.segnaletica = segnaletica;
            });
            this.wmaiservice.schedaStatoFondoById(this.idscheda, this.translateService.getDefaultLang()).subscribe(stato_fondo => {
              if (stato_fondo != null && stato_fondo.length > 0)
                this.schedaintense.stato_fondo = stato_fondo;
            });
            this.wmaiservice.schedaTipoFondoById(this.idscheda, this.translateService.getDefaultLang()).subscribe(tipo_fondo => {
              if (tipo_fondo != null && tipo_fondo.length > 0)
                this.schedaintense.tipo_fondo = tipo_fondo;
            });
            this.wmaiservice.schedaTematicaById(this.idscheda, this.translateService.getDefaultLang()).subscribe(tematica => {
              if (tematica != null && tematica.length > 0)
                this.schedaintense.tematica = tematica;
            });
            this.wmaiservice.schedaTipologiaById(this.idscheda, this.translateService.getDefaultLang()).subscribe(tipologia => {
              if (tipologia != null && tipologia.length > 0)
                this.schedaintense.tipologia = tipologia;
            });
            this.wmaiservice.schedaImmaginiById(this.idscheda, this.translateService.getDefaultLang()).subscribe(immagini => {
              if (immagini != null && immagini.length > 0) {
                this.schedaintense.immagine = immagini;
                this.immagine = this.schedaintense.immagine[0];
                this.maxIndex = this.schedaintense.immagine.length - 1;
              }
            });
            this.wmaiservice.schedaAllegatiById(this.idscheda, this.translateService.getDefaultLang()).subscribe(allegati => {
              if (allegati != null && allegati.length > 0)
                this.schedaintense.allegati = allegati;
            });

            /*
            this.immagini = [];
            if (this.schedaintense['immagine'] != null) {
              let tmp: string = this.schedaintense['immagine'];
              let imgs = tmp.split(';').filter(Boolean);
              this.immagini = imgs;
              this.maxIndex = this.immagini.length -1;
              this.immagine = this.immagini[0];
            }
            */

            this.wmaiservice.queryListEsperienzeById(this.idscheda, this.translateService.getDefaultLang()).subscribe(data => {
              this.esperienze.push(...data);
            });

            this.wmaiservice.querySchedaTappeByIdScheda(this.idscheda, this.translateService.getDefaultLang()).subscribe(data => {
              if (data != null && data.length > 0) {
                this.tappe.push(...data);
                this.tappe.forEach(tappa => {
                  this.wmaiservice.querySchedaOstsByTappa(this.idscheda, tappa.titolo, this.translateService.getDefaultLang()).subscribe(data => {
                    tappa.OSTS = data;

                  });
                });
              }
            });

            this.wgisservice.showSchedaIntenseByObj(this.schedaintense);
          } else {
            this.router.navigate(['**']);
          }
        });

        this.getWordsSegnalazioneIntense();
        this.loading = false;
      }
    });
  }

  ngOnDestroy() {
    this.wgisservice.clearSelection();
    this.paramsSubscription.unsubscribe();
  }

  resetVariables(){
    this.tappe = [];
    this.selectedTappa = null;

    this.osts= [];
    this.selectedOst = null;
    this.ostAllegati = [];
    this.ostImmagini = [];
    this.ostImmagine = null
    this.currentOstIndex = 0;
    this.maxOstIndex = 0;
    this.immagine = null;
    this.currentIndex = 0;
    this.maxIndex  = 0;
  }

  /**
   * se l'utente è autentificato allora si crea l'esperienza
   */
  creaEsperienza() {
    if (this.schedaintense != null) {
      if (this.isUserLoggedIn) {
        this.wmaiservice.createEsperienza(this.schedaintense.id, this.translateService.getDefaultLang()).subscribe(data => {
          let newid = data['id'];
          if (newid != null) {
            // console.log("creta nuova esperienza");
            this.router.navigate(['esperienza/edit', newid]);
          }
        });
      } else {
        this.router.navigate(['login']);
      }
    }
  }

  displaymap() {
    this.wgisservice.cmdToggleMap();
    this.wgisservice.wgisVisible.subscribe((mode: WGisDisplayMode) => {
      this.isMapVisible = (mode !== WGisDisplayMode.Invisible);
    });
  }

  nextImage() {
    if (this.currentIndex >= this.maxIndex) this.currentIndex = 0;
    else this.currentIndex++;
    this.immagine = this.schedaintense.immagine[this.currentIndex];
  }

  previousImage() {
    if (this.currentIndex <= 0) this.currentIndex = this.maxIndex;
    else this.currentIndex--;
    this.immagine = this.schedaintense.immagine[this.currentIndex];
  }
  /**
   * si chiede la traduzione della segnalazione
   */
  getWordsSegnalazioneIntense() {
    this.wmaiservice.getWordsByLocale(this.translateService.getDefaultLang(), 'segnalazioneIntense').subscribe(data => {
      this.wordsSegnalazione = data;
    });
  }

  toggleSegnalazione() {
    this.showSegnalazione = !this.showSegnalazione;
  }
  /**
   * si crea una segnalazione attraverso un modal
   */
  submitSegnalazione() {
    if (this.idscheda == null) return;
    var params = this.segnalazioneForm.value;
    // console.log(params);
    let title: string = this.translateService.instant('modal.segnalazione.title');
    let content: string = this.translateService.instant('modal.segnalazione.confirm');
    this.modalService
      .open(new ConfirmModal(title, content, ModalSize.Tiny))
      .onApprove(() => {
        if (this.isUserLoggedIn) {
          this.wmaiservice.sendAlertToRas(this.idscheda, 'scheda', params).subscribe(data => {
            let title: string = this.translateService.instant('modal.segnalazione.title');
            let content: string = this.translateService.instant('modal.segnalazione.success');
            this.modalService
              .open(new SimpleModal(title, content, ModalSize.Tiny))
              .onApprove(() => {
              })
              .onDeny(() => "");
          });
        };
        this.router.navigate(['scheda/' + this.idscheda]);
        this.showSegnalazione = true;
      })
      .onDeny(() => "");
  }

  /** si punta all'Ost selezionato e attraverso ai parametri si vanno ad inserire degli allegati/immagini e poi si 
   * fa vedere il sisultato attraverso gli oggetti
   * @param  {Tappa} selectedTappa
   * @param  {Ost} selectedOst
   */
  onSelectedOst(selectedTappa: Tappa, selectedOst: Ost) {
    if (selectedOst != null && selectedTappa != null) {
      this.selectedTappa = selectedTappa;
      this.selectedOst = selectedOst;

      this.wmaiservice.ostSingleById(selectedOst.id, this.translateService.getDefaultLang()).subscribe(data => {
        if (data != null) {
          this.selectedOst = data[0];
          this.ostAllegati = [];
          this.ostImmagini = [];
          this.wmaiservice.ostImmaginiById(selectedOst.id, this.translateService.getDefaultLang()).subscribe(data => {
            if (data != null || data.length > 0) {
              this.ostImmagini = data;
              this.maxOstIndex = this.ostImmagini.length - 1;
              this.ostImmagine = this.ostImmagini[0];
            }
          });
          this.wmaiservice.ostAllegatiById(selectedOst.id, this.translateService.getDefaultLang()).subscribe(data => {
            if (data != null || data.length > 0) {
              this.ostAllegati = data;
            }
          });
        }
      });
      this.wgisservice.showOstByObj(this.selectedOst, true);
    }
  }

  nextOstImage() {
    if (this.currentOstIndex >= this.maxOstIndex) this.currentOstIndex = 0;
    else this.currentOstIndex++;
    this.ostImmagine = this.ostImmagini[this.currentOstIndex];
  }

  previousOstImage() {
    if (this.currentOstIndex <= 0) this.currentOstIndex = this.maxOstIndex;
    else this.currentOstIndex--;
    this.ostImmagine = this.ostImmagini[this.currentOstIndex];
  }

  checkIcon(allegato){
    if(allegato.title.match(/\.(pdf|txt|doc|docx|exel|PDF|TXT|DOC|DOCX|EXEL)$/)){
      return {"file alternate outline icon": true};
    } else if (allegato.title.match(/\.(mp3|MP3|wav|WAV|wma|WMA)$/)){
      return {"file audio outline icon" : true};
    } else if(allegato.title.match(/\.(3gp|avi|mp4|mpeg|mpg|3GP|AVI|MP4|MPEG|MPG)$/)){
      return {"file video outline icon": true};
    } else if(allegato.title.match(/\.(jpg|jpeg|png|gif|bmp|JPG|JPEG|PNG|GIF|BMP)$/)){
      return {"file image outline icon": true};
    } else {
      return {"download icon": true};
    }
  }
}
